import createIcon from '../../createIcon';

/**
 * @component @name FolderSpecial
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgNkgxMkwxMCA0SDRDMi45IDQgMiA0LjkgMiA2VjE4QzIgMTkuMSAyLjkgMjAgNCAyMEgyMEMyMS4xIDIwIDIyIDE5LjEgMjIgMThWOEMyMiA2LjkgMjEuMSA2IDIwIDZaTTE3Ljk0IDE3TDE1IDE1LjI4TDEyLjA2IDE3TDEyLjg0IDEzLjY3TDEwLjI1IDExLjQzTDEzLjY2IDExLjE0TDE1IDhMMTYuMzQgMTEuMTRMMTkuNzUgMTEuNDNMMTcuMTYgMTMuNjdMMTcuOTQgMTdaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FolderSpecial = createIcon('FolderSpecial', [
  [
    'path',
    {
      d: 'M20 6H12L10 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V8C22 6.9 21.1 6 20 6ZM17.94 17L15 15.28L12.06 17L12.84 13.67L10.25 11.43L13.66 11.14L15 8L16.34 11.14L19.75 11.43L17.16 13.67L17.94 17Z',
      key: '859blr',
    },
  ],
]);

export default FolderSpecial;
